export default "__VITE_ASSET__5drNcT1B__"